export default __webpack_public_path__ + "static/media/login-user-icon.b0ec521a.svg";